export default {
    food: "Đồ ăn",
    watch: "Đồng hồ",
    normal: "Normal",
    sensitive: "Sensitive",
    superSensitive: "Super Sensitive",
    superSuperSensitive: "Super Super Sensitive",
    superSuperSuperSensitive: "Super Super Super Sensitive",
}
